<div style="overflow-y:auto; height: 100%; padding-right: 24px; overflow-x:hidden;">
  <nz-divider nzText="Demo" nzOrientation="left" nzPlain ></nz-divider>
  <nz-table #basicTable [nzData]="listOfData" class="w-full" [nzScroll]="{x: '1500px'}">
    <thead>
      <tr>
        <th>STT</th>
        <th>Ngày bắt đầu</th>
        <th>Ngày kết thúc</th>
        <th>Diễn giải</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data; let i = index;">
        <td>{{ i+1 }}</td>
        <td>{{ data.nqd }}</td>
        <td>{{ data.nqd }}</td>
        <td>{{ data.bac }}</td>
      </tr>
    </tbody>
  </nz-table>
</div>